// extracted by mini-css-extract-plugin
export default {"info-tooltip":"InfoBox_info-tooltip__I5svr","info-box":"InfoBox_info-box__Rhea+","info-icon--inverse":"InfoBox_info-icon--inverse__-yPdF"};